import commonApi from "@/api/common";
import {i18n} from "@/plugins/i18n";

const state = {
  employmentTypes: [],
  propertyBuildingStatus: ['ready_unit', 'sale_on_map', 'self_built', 'other'],
  propertyTypes: [],
  propertyTypesLocal: [
    { value: 'flat', name: i18n.t('propertyTypes.flat') },
    { value: 'house', name: i18n.t('propertyTypes.house')},
    { value: 'studio', name: i18n.t('propertyTypes.studio')},
    { value: 'hotel_apartment', name: i18n.t('propertyTypes.hotel_apartment')},
    { value: 'apartment', name: i18n.t('propertyTypes.apartment')},
    { value: 'villa', name: i18n.t('propertyTypes.villa')},
    { value: 'room', name: i18n.t('propertyTypes.room')},
    { value: 'other', name: i18n.t('propertyTypes.other')},
  ],
  cities: [],
  nationalities: [],
  maritalStatuses: [],
  simahCities: [],
};

export const mutationTypes = {
  getEmploymentTypes: "[common] getEmploymentTypes",
  setNationalities: "[common] setNationalities",
  setMaritalStatuses: "[common] setMaritalStatuses",
  setSimahCities: "[common] setSimahCities",
};

export const actionTypes = {
  getEmploymentTypes: "[common] getEmploymentTypes",
  getPropertyTypes: "[common] getPropertyTypes",
  getCities: "[common] getCities",
  getNationalities: "[common] getNationalities",
  getMaritalStatuses: "[common] getMaritalStatuses",
  getSimahCities: "[common] getSimahCities",
};

const mutations = {
  [mutationTypes.getEmploymentTypes](state, payload) {
    state.employmentTypes = payload;
  },

  setPropertyTypes(state, payload) {
    state.propertyTypes = payload
  },

  setCities(state, payload) {
    state.cities = payload.result
  },

  [mutationTypes.setNationalities](state, payload) {
    state.nationalities = payload;
  },

  [mutationTypes.setMaritalStatuses](state, payload) {
    state.maritalStatuses = payload;
  },

  [mutationTypes.setSimahCities](state, payload) {
    state.simahCities = payload;
  }
};

const actions = {
  async [actionTypes.getEmploymentTypes](context) {
    try {
      const response = await commonApi.getEmploymentTypes();
      context.commit(mutationTypes.getEmploymentTypes, response.data);
    } catch (e) {
      console.log(e.response.data.error);
    }
  },

  async [actionTypes.getPropertyTypes](context) {
    try {
      const response = await commonApi.getPropertyTypes();
      context.commit('setPropertyTypes', response.data)
      return response.data
    } catch (e) {
      console.log(e.response.data.error);
    }
  },

  async [actionTypes.getCities](context) {
    try {
      const response = await commonApi.getCities();
      context.commit('setCities', response.data)
      return response.data
    } catch (e) {
      console.log(e.response.data.error);
    }
  },

  async [actionTypes.getNationalities](context) {
    try {
      const response = await commonApi.getNationalities();
      context.commit(mutationTypes.setNationalities, response.data)
    } catch (e) {
      console.log(e.response.data.error);
    }
  },

  async [actionTypes.getMaritalStatuses](context) {
    try {
      const response = await commonApi.getMaritalStatuses();
      context.commit(mutationTypes.setMaritalStatuses, response.data)
    } catch (e) {
      console.log(e.response.data.error);
    }
  },

  async [actionTypes.getSimahCities](context) {
    try {
      const response = await commonApi.getSimahCities();
      context.commit(mutationTypes.setSimahCities, response.data)
    } catch (e) {
      console.log(e.response.data.error);
    }
  },
};

const getters = {};

export default {
  state,
  mutations,
  actions,
  getters
};
